export default __webpack_public_path__ + "1a01c940c0e9ac8743fc0bd7bec97e5d.png";